var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustedLogomarkMintBlack = function SvgTrustedLogomarkMintBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    fill: "none",
    viewBox: "0 0 24 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242329",
    d: "M21.213 26.87c-1.457.711-3.375 1.13-7.331 1.13-5.376 0-8.635-2.966-8.635-7.362V0h8.758v18.183c0 1.962.625 2.798 3.375 2.798 1.585 0 2.626-.294 3.833-.668z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87E0CC",
    d: "M18.523 13.552a4.46 4.46 0 0 0 2.827-.997 4.5 4.5 0 0 0 1.555-2.588l.74-3.678H0v7.28z"
  })));
};
export default SvgTrustedLogomarkMintBlack;